export type ProfileSessionId = {
  sessionId: string;
};

export enum EUserType {
  CUSTOMER = 'customer',
  VISITOR = 'visitor',
  USER = 'user',
}
